"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M10.8438 1.46316C10.5473 1.46316 10.3069 1.70351 10.3069 2C10.3069 2.29649 10.5473 2.53684 10.8438 2.53684V1.46316ZM18.0016 2H18.5385C18.5385 1.70351 18.2981 1.46316 18.0016 1.46316V2ZM17.4648 9.1579C17.4648 9.45438 17.7052 9.69474 18.0016 9.69474C18.2981 9.69474 18.5385 9.45438 18.5385 9.1579H17.4648ZM10.8438 2.53684H18.0016V1.46316H10.8438V2.53684ZM17.4648 2V9.1579H18.5385V2H17.4648Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M1 11.8421L10.8421 2",
      stroke: "currentColor",
      strokeWidth: "1.07368"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M8.15625 18.9998L17.9984 9.15771",
      stroke: "currentColor",
      strokeWidth: "1.07368"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M8.15625 11.8421L17.9984 2",
      stroke: "currentColor",
      strokeWidth: "1.07368"
    }), (0, jsx_runtime_1.jsx)("rect", {
      x: "1",
      y: "11.8423",
      width: "7.1579",
      height: "7.1579",
      stroke: "currentColor",
      strokeWidth: "1.07368",
      strokeLinejoin: "round"
    })]
  });
};

exports.default = Icon;